<template>
    <div class="tw-text-white tw-w-full lg:tw-max-w-4xl tw-mx-auto">
        <div class="tw-px-4 lg:tw-py-20 tw-text-center">
            <p class="tw-font-bold tw-text-xl">Obrigado pelo seu registo</p>
            <hr class="tw-my-2 tw-w-3/4 tw-mx-auto"/>
            <small class="tw-texr-sm tw-block">Será contactado em breve.</small>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSuccess',
};
</script>

<style lang="scss">
@import "~@/assets/scss/partials/_variables.scss";

.form-success {

}

</style>
